var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepperConnectingLine({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 293,
    viewBox: "0 0 2 293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 0.5L1.24999 292.5",
    stroke: "#8AC6FF",
    strokeWidth: 1.2,
    strokeDasharray: "2.4 2.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperConnectingLine);
export default __webpack_public_path__ + "static/media/stepper-connecting-line.46129b8d041fb4585a0316e13c48b822.svg";
export { ForwardRef as ReactComponent };